<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="group" :class="{ 'group-preview': isPreview }">
    <template v-if="isPreview">
      <component
        v-for="item in propValue"
        :is="item.component"
        :id="'component' + item.id"
        :key="item.id"
        :allBtnPressMap="allBtnPressMap"
        :isPreview="true"
        :currentComps="currentComps"
        class="component preview-child-comp"
        :style="item.groupStyle"
        :prop-value="item.propValue"
        :element="item"
        @changeCurComp="changeCurComp"
        @changePage="changePage"
        @changeBtnPress="changeBtnPress"
      />
    </template>
    <template v-else>
      <div v-for="item in propValue" :key="item.id">
        <component
          :is="item.component"
          :id="'component' + item.id"
          :key="item.id"
          class="component"
          :style="item.groupStyle"
          :prop-value="item.propValue"
          :element="item"
        />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    propValue: {
      type: Array,
      default: () => [],
    },
    element: {
      type: Object,
      default: () => {},
    },
    isPreview: Boolean,
    currentComps: {
      type: String,
      require: false
    },
    allBtnPressMap: {
      type: Object,
      require: false
    }
  },
  methods: {
    changeCurComp(datas) {
      this.$emit("changeCurComp", datas);
    },
    changePage(key) {
      this.$emit("changePage", key);
    },
    changeBtnPress(arr) {
      this.$emit("changeBtnPress", arr);
    },
  },
};
</script>

<style lang="scss" scoped>
.group {
  width: 100%;
  height: 100%;
  .preview-child-comp {
    position: absolute;
  }
  & > div {
    .component {
      position: absolute;
    }
  }
}
/* 编辑模式下整棵子树不拦截鼠标，由外层 Shape 统一处理选中与右键菜单 */
.group:not(.group-preview),
.group:not(.group-preview) * {
  pointer-events: none !important;
}
</style>
